
<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#81fd48"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#81fd48" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <template v-if="newDashboard">
    <v-layout wrap justify-center>
      <v-flex xs12 text-left>
        <span class="itemHeading"> Dashboard </span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start pb-10 pt-5>
      <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-sm-0 text-left>
        <v-card rounded="lg" elevation="1" height="100%">
          <v-layout wrap justify-end pa-4 fill-height class="bg1">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left>
                  <span class="analyticsValue">
                    {{ newDashboard.activeCustomers }}
                  </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <router-link to="/CustomerList" style="text-decoration: none">
                    <span class="analyticsKey"> Active Customers</span>
                    <span class="itemArrow"> >> </span>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/users.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-sm-0 text-left>
        <v-card rounded="lg" elevation="1" height="100%">
          <v-layout wrap justify-end pa-4 fill-height class="bg3">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-end>
                <v-flex xs12 text-left align-self-end>
                  <v-dialog
                    :retain-focus="false"
                    v-model="isNotify"
                    persistent
                    max-width="600px"
                    :key="isNotify"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <span class="analyticsKey"> Send Notification</span>
                        <span class="itemArrow"> >> </span></span
                      >
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">SEND NOTIFICATION</span>
                      </v-card-title>
                      <v-card-text>
                        <!-- <v-container> -->

                        <v-layout wrap>
                          <v-flex xs12 pt-5>
                            <v-text-field
                              :rules="[rules.required]"
                              v-model="notifyTitle"
                              label="Title"
                              outlined
                              dense
                            >
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              outlined
                              dense
                              :rules="[rules.required]"
                              v-model="notifyMessage"
                              label="Message"
                              rows="4"
                            >
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="isNotify = false"
                        >
                          Close
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="sendNotification()"
                        >
                          Submit
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/program.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <!-- 
      <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-sm-0 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg3">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left>
                  <span class="analyticsValue">
                    {{ dashboard.activeSellers }}
                  </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <router-link
                    to="/SellerList?status=Active"
                    style="text-decoration: none"
                  >
                    <span class="analyticsKey"> Active Sellers</span>
                    <span class="itemArrow"> >> </span>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/sellers.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 lg3 xl3 pl-0 pl-lg-4 pt-4 pt-sm-4 pt-lg-0 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg4">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left>
                  <span class="analyticsValue">
                    {{ dashboard.pendingSellers }}
                  </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <router-link
                    to="/SellerList?status=Pending"
                    style="text-decoration: none"
                  >
                    <span class="analyticsKey"> Pending Sellers</span>
                    <span class="itemArrow"> >> </span>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/sellers.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-lg-0 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg5">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left>
                  <span class="analyticsValue">
                    {{ dashboard.products }}
                  </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <router-link to="/Food" style="text-decoration: none">
                    <span class="analyticsKey"> Products</span>
                    <span class="itemArrow"> >> </span>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/product.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-sm-4 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg2">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left>
                  <span class="analyticsValue">
                    {{ dashboard.orders }}
                  </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <router-link
                    to="/orderList?type=total"
                    style="text-decoration: none"
                  >
                    <span class="analyticsKey"> Total Orders</span>
                    <span class="itemArrow"> >> </span>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/program.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-sm-4 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg1">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left>
                  <span class="analyticsValue">
                    {{ dashboard.todaysOrders }}
                  </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <router-link to="/orderList" style="text-decoration: none">
                    <span class="analyticsKey"> Today's Orders</span>
                    <span class="itemArrow"> >> </span>
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/program.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      -->

      <v-flex xs12 md6 pl-0 pl-sm-4 pt-4 pt-sm-0 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg2">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left pb-2>
                  <span
                    class="analyticsKey"
                    style="border-bottom: 1px solid white"
                  >
                    Today's Orders</span
                  >
                  <span class="itemArrow"> >> </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <v-layout wrap>
                    <v-flex xs6>
                      <router-link
                        to="/orderList"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.foodTodaysOrders
                        }}</span>
                        <br />
                        <span class="analyticsKey"> in Food </span>
                      </router-link>
                    </v-flex>
                    <v-flex xs6>
                      <router-link
                        to="/groceryOrderList"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.GroceryTodaysOrders
                        }}</span>
                        <br />
                        <span class="analyticsKey">in Grocery</span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/program.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 md6 pl-0 pl-sm-4 pt-4 pt-sm-4 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg4">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left pb-2>
                  <span
                    class="analyticsKey"
                    style="border-bottom: 1px solid white"
                  >
                    Active Sellers</span
                  >
                  <span class="itemArrow"> >> </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <v-layout wrap>
                    <v-flex xs6>
                      <router-link
                        to="/SellerList?status=Active"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.activeFoodSellers
                        }}</span>
                        <br />
                        <span class="analyticsKey"> in Food </span>
                      </router-link>
                    </v-flex>
                    <v-flex xs6>
                      <router-link
                        to="/GocerySeller?status=Active"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.activeGrocerySellers
                        }}</span>
                        <br />
                        <span class="analyticsKey">in Grocery</span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/sellers.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12 md6 pl-0 pl-sm-4 pt-4 pt-sm-4 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg6">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left pb-2>
                  <span
                    class="analyticsKey"
                    style="border-bottom: 1px solid white"
                  >
                    Pending Sellers</span
                  >
                  <span class="itemArrow"> >> </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <v-layout wrap>
                    <v-flex xs6>
                      <router-link
                        to="/SellerList?status=Pending"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.pendingFoodSellers
                        }}</span>
                        <br />
                        <span class="analyticsKey"> in Food </span>
                      </router-link>
                    </v-flex>
                    <v-flex xs6>
                      <router-link
                        to="/GocerySeller?status=Pending"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.pendingGrocerySellers
                        }}</span>
                        <br />
                        <span class="analyticsKey">in Grocery</span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/sellers.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 pl-0 pl-sm-4 pt-4 pt-sm-4 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg7">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left pb-2>
                  <span
                    class="analyticsKey"
                    style="border-bottom: 1px solid white"
                  >
                    Products</span
                  >
                  <span class="itemArrow"> >> </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <v-layout wrap>
                    <v-flex xs6>
                      <router-link to="/Food" style="text-decoration: none">
                        <span class="analyticsValue">{{
                          newDashboard.foodProduct
                        }}</span>
                        <br />
                        <span class="analyticsKey"> in Food </span>
                      </router-link>
                    </v-flex>
                    <v-flex xs6>
                      <router-link
                        to="/Groceryproduct"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.GroceryProduct
                        }}</span>
                        <br />
                        <span class="analyticsKey">in Grocery</span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/product.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 pl-0 pl-sm-4 pt-4 pt-sm-4 text-left>
        <v-card rounded="lg" elevation="1">
          <v-layout wrap justify-end pa-4 class="bg1">
            <v-flex xs9 xl7 text-left>
              <v-layout wrap justify-center>
                <v-flex xs12 text-left pb-2>
                  <span
                    class="analyticsKey"
                    style="border-bottom: 1px solid white"
                  >
                    Total orders</span
                  >
                  <span class="itemArrow"> >> </span>
                </v-flex>
                <v-flex xs12 text-left>
                  <v-layout wrap>
                    <v-flex xs6>
                      <router-link
                        to="/OrderList"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.foodOrders
                        }}</span>
                        <br />
                        <span class="analyticsKey"> in Food </span>
                      </router-link>
                    </v-flex>

                    <v-flex xs6>
                      <router-link
                        to="/groceryOrderList"
                        style="text-decoration: none"
                      >
                        <span class="analyticsValue">{{
                          newDashboard.GroceryOrders
                        }}</span>
                        <br />
                        <span class="analyticsKey">in Grocery</span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3 xl4 text-center align-self-center>
              <v-img
                src="./../../assets/images/program.png"
                height="50px"
                contain
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    </template>
  </div>
</template>
<script>
import axios from "axios";
// import Analytics from "./analytics";t
// import GraphData from "./graphData";
export default {
  components: {
    // Analytics,
    // GraphData,
  },
  data() {
    return {
      newDashboard: null,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      isNotify: false,
      dashboard: [],
      rules: {
        required: (value) => !!value || "Required.",
      },
      notifyTitle: "",
      notifyMessage: "",
    };
  },
  // beforeMount() {
  //   this.getData();
  // },
mounted()
{
this.getData();
},

  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/admin/dashboard",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.dashboard = response.data.data;
            this.newDashboard = response.data.newData;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    sendNotification() {
      this.appLoading = true;
      axios({
        method: "post",
        url: "/send/notification/all/customers",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          title: this.notifyTitle,
          message: this.notifyMessage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.isNotify = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style >
.bg1 {
  background-image: linear-gradient(to right, #00f2fe 0%, #4facfe 100%);
}
.bg2 {
  background-image: linear-gradient(to right, #f093fb 0%, #f5576c 100%);
}
.bg3 {
  background-image: linear-gradient(to right, #43e97b 0%, #38f9d7 100%);
}
.bg4 {
  background-image: linear-gradient(to right, #fa709a 0%, #fee140 100%);
}
.bg5 {
  background-image: linear-gradient(to right, #43e97b 0%, #fee140 100%);
}
.bg6 {
  background-image: linear-gradient(to right, #7b6bd6 0%, #93d6e5 100%);
}
.bg7 {
  background-image: linear-gradient(to right, #6cdc6e 0%, #c1cfd2 100%);
}
</style>